import React from 'react'

import Navbar from '../defaultComponents/Navbar.jsx'
import Footer from '../defaultComponents/Footer.jsx'

import TextField from '@mui/material/TextField';

import {
  useNavigate
} from "react-router-dom";

export default function ForgotPass() {
  const [email, setEmail] = React.useState('')
  const [password, setPassword] = React.useState('')
  const navigate = useNavigate('')

  const handleFirstnameFilter = (event) => {
    setEmail(event.target.value);
  }

  const handleLastnameFilter = (event) => {
    setPassword(event.target.value);
  }

  const handleRecover = () => {

  }

  return (    
    <>
      <Navbar/>
      <div className="all-page-background" style={{background: "#F8F8F8", width: "100%", height: "100%"}}>
      <div className="user-access-wrapper">
        <div className="login-box">
          
          <div className="page-title">Forgot Password</div>
          <div className="device-search-wrapper">
            <TextField
              id="standard-search"
              label="Email"
              variant="standard"
              color='error'
              value = {email}
              onChange={handleFirstnameFilter}
            />
          </div>
  
          <div className="device-buttons-bar device-filter-bar">
            <div className="login-button" onClick={handleRecover}>Send recovey email</div>
          </div>
  
        </div>
  
      </div>
       
      <Footer/>
      </div>
    </>
    )
}
